/**
 * Copyright (c) 2014, Facebook, Inc. All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */
exports.modulePath = 'subdir2/__mocks__/MyModule.js';



//////////////////
// WEBPACK FOOTER
// ./~/jest-cli/src/HasteModuleLoader/__tests__/test_root/subdir2/__mocks__/MyModule.js
// module id = 561
// module chunks = 0